import React from 'react';
import { Home, FileText, UserCircle, LogIn, X } from 'lucide-react';

const Navbar = ({ isLoggedIn, handleLogout, setCurrentPage, mobileMenuOpen, setMobileMenuOpen, user }) => {
  const navigate = (page) => {
    if (page === 'logout') {
      handleLogout();
    } else {
      setCurrentPage(page);
    }
  };

  return (
    <nav className="bg-teal-600 text-white shadow-lg">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16">
          <div className="flex items-center">
            <span className="text-xl font-bold cursor-pointer" onClick={() => navigate('home')}>MenuAnalyzer.AI</span>
          </div>
          
          {/* Desktop navigation */}
          <div className="hidden md:flex items-center space-x-4">
            <button 
              onClick={() => navigate('home')} 
              className={`px-3 py-2 rounded-md text-sm font-medium hover:bg-teal-700`}
            >
              <Home className="inline mr-1 h-4 w-4" />
              Home
            </button>
            
            {isLoggedIn ? (
              <>
                <button 
                  onClick={() => navigate('app')} 
                  className={`px-3 py-2 rounded-md text-sm font-medium hover:bg-teal-700`}
                >
                  <FileText className="inline mr-1 h-4 w-4" />
                  Analyze Menu
                </button>
                <button 
                  onClick={() => navigate('profile')} 
                  className={`px-3 py-2 rounded-md text-sm font-medium hover:bg-teal-700`}
                >
                  <UserCircle className="inline mr-1 h-4 w-4" />
                  Profile
                </button>
                <button 
                  onClick={handleLogout} 
                  className="px-3 py-2 rounded-md text-sm font-medium hover:bg-teal-700"
                >
                  Logout
                </button>
              </>
            ) : (
              <button 
                onClick={() => setCurrentPage('auth')} 
                className={`px-3 py-2 rounded-md text-sm font-medium hover:bg-teal-700`}
              >
                <LogIn className="inline mr-1 h-4 w-4" />
                Login / Register
              </button>
            )}
          </div>
          
          {/* Mobile menu button */}
          <div className="md:hidden flex items-center">
            <button 
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              className="text-white hover:bg-teal-700 p-2 rounded-md"
            >
              {mobileMenuOpen ? <X className="h-6 w-6" /> : <div className="h-6 w-6 flex flex-col justify-center items-center space-y-1">
                <div className="w-5 h-0.5 bg-white rounded-full"></div>
                <div className="w-5 h-0.5 bg-white rounded-full"></div>
                <div className="w-5 h-0.5 bg-white rounded-full"></div>
              </div>}
            </button>
          </div>
        </div>
      </div>
      
      {/* Mobile navigation */}
      {mobileMenuOpen && (
        <div className="md:hidden bg-teal-700 pb-3 pt-2">
          <div className="px-2 space-y-1">
            <button 
              onClick={() => navigate('home')}
              className="block px-3 py-2 rounded-md text-base font-medium text-white hover:bg-teal-800 w-full text-left"
            >
              <Home className="inline mr-2 h-5 w-5" />
              Home
            </button>
            
            {isLoggedIn ? (
              <>
                <button 
                  onClick={() => navigate('app')}
                  className="block px-3 py-2 rounded-md text-base font-medium text-white hover:bg-teal-800 w-full text-left"
                >
                  <FileText className="inline mr-2 h-5 w-5" />
                  Analyze Menu
                </button>
                <button 
                  onClick={() => navigate('profile')}
                  className="block px-3 py-2 rounded-md text-base font-medium text-white hover:bg-teal-800 w-full text-left"
                >
                  <UserCircle className="inline mr-2 h-5 w-5" />
                  Profile
                </button>
                <button 
                  onClick={handleLogout}
                  className="block px-3 py-2 rounded-md text-base font-medium text-white hover:bg-teal-800 w-full text-left"
                >
                  Logout
                </button>
              </>
            ) : (
              <button 
                onClick={() => navigate('auth')}
                className="block px-3 py-2 rounded-md text-base font-medium text-white hover:bg-teal-800 w-full text-left"
              >
                <LogIn className="inline mr-2 h-5 w-5" />
                Login / Register
              </button>
            )}
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
